export default "__VITE_ASSET__Dg1Uh36i__"